import { Http } from '@mygpt/app/http';
import { DatasetsInfo } from '@mygpt/app/datasets/services';

// 定义 AI 模型类型
export enum AIModelType {
  WEBSITE = 'website',
  FILE = 'file',
  LARK_FILE = 'lark_file',
  GBASE_PROJECT = 'gbase_project',
  EMPTY = '',
}

interface CreateRobotParams {
  name?: string;
  url?: string;
  datasetId?: string;
  aiModel: AIModelType;
  embeddingModelName?: string;
  companyId?: string | null;
}

interface BindDtatesetsParams {
  aiId: string;
  datasetId: string;
}

interface CreateRobotResponse {
  id: string;
  created_at: string;
  name: string;
  discrible: string | null;
  subject_name: string | null;
  prompt: string | null;
  robot_type: string;
  ai_type: string;
  ai_model: string;
  ai_status: string;
  user: {
    user_id: string;
    email: string;
    name: string;
    salt: string | null;
    picture: string;
    locale: string | null;
    corporate: boolean;
    is_independent: boolean;
  };
  datasets: Array<{
    id: string;
    created_at: string;
    updated_at: string;
    data_status: string;
    name: string;
    description: string | null;
    metadata: {
      vector_storage: string;
      faq_vector_storage: string;
      embedding_model_name: string;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    url_rules: any[];
    user_id: string;
  }>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  questions: any[];
  file_count: number;
  faq_count: number;
  error?: string;
}

/**
 * 创建机器人自动创建数据集
 * @param params
 * @returns Promise<CreateRobotResponse>
 *
 * file 类型，name必填
 * website类型，url必填
 * 如果填入dataset_id，name必填。（不区分bot类型）
 */
export const createRobotDatasets = (params: CreateRobotParams) => {
  const { post } = Http.use();
  const { embeddingModelName, name, url, companyId } = params;
  const addParams = {
    name: name || url,
    description: '',
    embedding_model_name: embeddingModelName || 'text-embedding-3-large',
    ...(companyId && { company_id: companyId }),
  };
  return post<DatasetsInfo>(`/datasets`, addParams);
  // const { post } = Http.use();

  // const requestParams = {
  //   ai_model: aiModel,
  //   embedding_model_name: embeddingModelName,
  // };

  // if (aiModel === AIModelType.WEBSITE) Object.assign(requestParams, { url });
  // if (aiModel === AIModelType.FILE) Object.assign(requestParams, { name });
  // if (aiModel === AIModelType.EMPTY) Object.assign(requestParams, { dataset_id: datasetId });

  // return post<CreateRobotResponse>(`/ais`, requestParams);
};

/**
 * 机器人绑定数据集
 * @param params
 * @returns
 */
export const bindDatasets = (params: BindDtatesetsParams) => {
  const { aiId, datasetId } = params;
  const { post } = Http.use();
  return post(`/robots/${aiId}/datasets/${datasetId}`);
};

/**
 * 机器人解绑数据集
 * @param params
 * @returns
 */
export const unbindDatasets = (params: BindDtatesetsParams) => {
  const { aiId, datasetId } = params;
  const { delete: _delete } = Http.use();
  return _delete(`/robots/${aiId}/datasets/${datasetId}`);
};
